import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const Points = styled.div.withConfig({
    displayName: "styled__Points",
    componentId: "sc-6454c2a3-0"
})``;
export const Link = styled.a.withConfig({
    displayName: "styled__Link",
    componentId: "sc-6454c2a3-1"
})``;
export const Point = styled.div.withConfig({
    displayName: "styled__Point",
    componentId: "sc-6454c2a3-2"
})`
	box-shadow:
		0 1px 3px ${(props)=>props.theme.colors.black.high},
		0 1px 2px ${(props)=>props.theme.colors.black.higher};
	transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 0.1);
	position: absolute;
	${FlexMixin({
    align: 'center',
    justify: 'center'
})}
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background-color: ${(props)=>props.theme.colors.white.base};
	color: ${(props)=>props.theme.colors.primary.light};
	${FontMixin({
    size: 'small',
    height: 'small'
})}

	:hover {
		background-color: ${(props)=>props.theme.colors.primary.base};
		outline: none;
		a {
			color: ${(props)=>props.theme.colors.white.base};
		}
	}

	// IT

	&.point2807 {
		top: 255px;
		left: 246px;
	}

	&.point2900 {
		top: 345px;
		right: 136px;
	}

	&.point30017101 {
		top: 300px;
		right: 83px;
	}

	&.point8355 {
		top: 340px;
		right: 61px;
	}

	&.point8365 {
		top: 260px;
		right: 150px;
	}

	&.point9487 {
		top: 230px;
		right: 104px;
	}

	&.point9702 {
		top: 119px;
		right: 149px;
	}

	&.point9466 {
		top: 91px;
		right: 178px;
	}

	&.point10123 {
		top: 190px;
		left: 279px;
	}

	&.point17583 {
		top: 250px;
		left: 52px;
	}

	&.point9399 {
		top: 330px;
		left: 112px;
	}

	&.point19132 {
		top: 181px;
		right: 101px;
	}

	&.point19149 {
		top: 100px;
		left: 266px;
	}

	&.point17678 {
		bottom: 147px;
		right: 118px;
	}

	&.point10148 {
		bottom: 168px;
		right: 86px;
	}

	&.point2708 {
		bottom: 212px;
		right: 46px;
	}

	&.point9316 {
		top: 46px;
		right: 192px;
	}

	&.point19151 {
		bottom: 180px;
		right: 10px;
	}

	@media (max-width: 1350px) {
		&.point2807 {
			top: 255px;
			left: 246px;
		}

		&.point2900 {
			top: 345px;
			right: 327px;
		}

		&.point30017101 {
			top: 300px;
			right: 272px;
		}

		&.point8355 {
			top: 340px;
			right: 250px;
		}

		&.point8365 {
			top: 260px;
			right: 341px;
		}

		&.point9487 {
			top: 230px;
			right: 292px;
		}

		&.point9702 {
			top: 119px;
			right: 338px;
		}

		&.point9466 {
			top: 91px;
			right: 368px;
		}

		&.point10123 {
			top: 190px;
			left: 279px;
		}

		&.point17583 {
			top: 250px;
			left: 52px;
		}

		&.point9399 {
			top: 330px;
			left: 112px;
		}

		&.point19132 {
			top: 181px;
			right: 291px;
		}

		&.point19149 {
			top: 100px;
			left: 266px;
		}

		&.point17678 {
			bottom: 147px;
			right: 309px;
		}

		&.point10148 {
			bottom: 168px;
			right: 277px;
		}

		&.point2708 {
			bottom: 212px;
			right: 238px;
		}

		&.point9316 {
			top: 46px;
			right: 381px;
		}

		&.point19151 {
			bottom: 180px;
			right: 200px;
		}
	}

	//ES

	&.point9255 {
		top: 87px;
		right: 60px;
	}

	&.point10211 {
		top: 110px;
		right: 86px;
	}

	&.point9259 {
		top: 132px;
		right: 113px;
	}

	&.point9252 {
		top: 162px;
		right: 140px;
	}

	&.point9253 {
		top: 195px;
		right: 157px;
	}

	&.point9251 {
		top: 241px;
		right: 149px;
	}

	&.point9258 {
		top: 271px;
		right: 186px;
	}

	&.point9254 {
		top: 297px;
		right: 226px;
	}

	&.point9249 {
		top: 275px;
		right: 273px;
	}

	&.point9250 {
		top: 311px;
		left: 398px;
	}

	&.point9257 {
		top: 316px;
		left: 343px;
	}

	&.point9256 {
		top: 281px;
		left: 319px;
	}

	&.point9263 {
		top: 233px;
		right: 81px;
	}

	&.point9262 {
		top: 10px;
		left: 287px;
	}

	&.point9261 {
		top: 5px;
		right: 336px;
	}

	&.point9260 {
		top: 13px;
		right: 273px;
	}

	&.point2397 {
		top: 250px;
		left: 178px;
	}

	&.point2379 {
		top: 300px;
		left: 178px;
	}

	&.point2383 {
		top: 335px;
		left: 126px;
	}

	&.point2428 {
		top: 285px;
		left: 106px;
	}

	&.point2381 {
		top: 325px;
		left: 65px;
	}

	&.point2387 {
		top: 330px;
		left: 18px;
	}

	&.point2395 {
		top: 265px;
		left: 35px;
	}

	&.point9264 {
		top: 266px;
		left: 274px;
	}

	&.point10216 {
		top: 225px;
		left: 280px;
	}

	&.point9266 {
		top: 200px;
		left: 252px;
	}

	&.point9265 {
		top: 137px;
		left: 266px;
	}

	&.point9267 {
		top: 87px;
		left: 273px;
	}

	&.point7277 {
		top: 192px;
		right: 90px;
	}

	&.point7272 {
		top: 198px;
		right: 31px;
	}

	&.point7273 {
		top: 146px;
		right: 14px;
	}

	//PT Island
	&.point10512 {
		top: 178px;
		left: 79px;
	}

	&.point1622 {
		top: 215px;
		left: 155px;
	}

	&.point10509 {
		top: 194px;
		left: 206px;
	}

	&.point10513 {
		top: 117px;
		left: 8px;
	}

	&.point10517 {
		top: 155px;
		left: 30px;
	}

	&.point10520 {
		top: 117px;
		left: 61px;
	}

	// FR
	&.point7751 {
		bottom: 40px;
		right: 258px;
	}

	&.point9330 {
		top: 315px;
		right: 318px;
	}

	&.point9336 {
		top: 0;
		left: 288px;
	}

	&.point9335 {
		top: 44px;
		left: 170px;
	}

	&.point8726 {
		top: 50px;
		left: 155px;
	}

	&.point17041 {
		top: 18px;
		right: 224px;
	}

	&.point19596 {
		bottom: 115px;
		left: 121px;
	}

	&.point9332 {
		bottom: 90px;
		left: 266px;
	}

	&.point17044 {
		bottom: 167px;
		left: 148px;
	}

	&.point19972 {
		top: 149px;
		left: 146px;
	}

	&.point19974 {
		top: 52px;
		left: 78px;
	}
`;

//# sourceMappingURL=styled.js.map